export default __webpack_public_path__ + "static/media/ProximaNova-Alt-Light.3a7c914c.otf";